/**
 * A12 (uwagi Bronka, raport 2026-10-19): „liczba lokali" w oknie „Zaplanuj przegląd" — LUSTRO
 * `apartmentCountError` z backend/src/services/scheduleImport.js (serwer jest jedynym strażnikiem;
 * tu tylko komunikat przy polu). Zmieniasz regułę tutaj → zmień ją także w backendzie.
 */
export const MAX_PLANNED_APARTMENTS = 500;

/** Puste = brak (null); inaczej liczba całkowita 1..500 albo komunikat. */
export function apartmentCountError(raw: string): string | null {
  const s = (raw ?? '').trim();
  if (s === '') return null;
  if (!/^\d+$/.test(s) || Number(s) < 1 || Number(s) > MAX_PLANNED_APARTMENTS) {
    return `Podaj liczbę lokali od 1 do ${MAX_PLANNED_APARTMENTS}`;
  }
  return null;
}
